export const ProspectiveMSS = 1;
export const ApplicantMSS = 2;
export const StudentMSS = 3;
export const GraduatedMSS = 4;
export const CancelledMSS = 5;

export const ProspectiveISS = 1;

export const AppliedISS = 1;
export const ReceivedDocsISS = 2;
export const I20issuedISS = 3;
export const GotApprovedISS = 4;
export const StartNextTermISS = 5;

export const ActiveISS = 1;

export const TransferredOutISS = 1;
export const TerminatedISS = 2;
export const CompletedISS = 3;

export const CancelledInnerISS = 1;
